module.exports = __webpack_public_path__ + "img/04高玉科.6d3daf53.png";